import { finish, error } from '../../../modules/customers/actions/remove-payment-method';

import api from '../../../api';

export function request(dispatch, { customerId, paymentMethodId }) {
    api.request('DELETE', '/customers/' + customerId + '/payment-methods/' + paymentMethodId).then(
        () => dispatch(finish(customerId)),
        ({ errors }) => dispatch(error(customerId, errors))
    );
}
